import { useEffect } from 'react'
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom'
import { addressWithoutLoginHint } from './auth/linkHint'
import { AppShell } from './components/shell/AppShell'

import Home from './pages/Home'
import AccountsList from './pages/accounts/AccountsList'
import AccountWorkspace from './pages/accounts/AccountWorkspace'
import ContactsList from './pages/contacts/ContactsList'
import ContactDetail from './pages/contacts/ContactDetail'
import OpportunitiesList from './pages/opportunities/OpportunitiesList'
import OpportunityDetail from './pages/opportunities/OpportunityDetail'
import FundsList from './pages/funds/FundsList'
import FundDetail from './pages/funds/FundDetail'
import PropertiesList from './pages/properties/PropertiesList'
import PropertyDetail from './pages/properties/PropertyDetail'
import Tasks from './pages/Tasks'
import SymposiumConsole from './pages/events/SymposiumConsole'
import Calendar from './pages/Calendar'
import Insights from './pages/Insights'
import NotFound from './pages/NotFound'

export default function App() {
  // Signed in: the link's ?login_hint has done its work. An address copied
  // from here into Teams must not carry THIS person's hint — the colleague
  // who opens it would be signed in as, or asked the password of, somebody
  // else (auth/linkHint.ts). The path, the hash and every other query key
  // stay. Through the ROUTER (replace), not history.replaceState behind its
  // back: BrowserRouter would keep the old search, and the next
  // setSearchParams (Tasks' ?new=1) would write the hint straight back.
  // Scaffold addition (sign-in wrap), like the callback route below.
  const navigate = useNavigate()
  useEffect(() => {
    const url = addressWithoutLoginHint(window.location.pathname, window.location.search, window.location.hash)
    if (url !== null) navigate(url, { replace: true })
  }, [navigate])

  return (
    <Routes>
      {/* MSAL redirect-URI target (see auth/msalConfig.ts). After MSAL
          processes the top-level redirect it restores the original URL
          (navigateToLoginRequestUrl default), so this route only renders
          transiently — bounce home rather than flashing NotFound. Scaffold
          addition; everything below is Jason Lopez's prototype untouched. */}
      <Route path="auth/callback" element={<Navigate to="/" replace />} />
      <Route element={<AppShell />}>
        <Route index element={<Home />} />
        <Route path="accounts" element={<AccountsList />} />
        <Route path="accounts/:accountId" element={<AccountWorkspace />} />
        <Route path="accounts/:accountId/:tab" element={<AccountWorkspace />} />
        <Route path="contacts" element={<ContactsList />} />
        <Route path="contacts/:id" element={<ContactDetail />} />
        <Route path="opportunities" element={<OpportunitiesList />} />
        <Route path="opportunities/:id" element={<OpportunityDetail />} />
        <Route path="funds" element={<FundsList />} />
        <Route path="funds/:id" element={<FundDetail />} />
        <Route path="properties" element={<PropertiesList />} />
        <Route path="properties/:id" element={<PropertyDetail />} />
        <Route path="events/symposium" element={<SymposiumConsole />} />
        <Route path="tasks" element={<Tasks />} />
        <Route path="calendar" element={<Calendar />} />
        <Route path="insights" element={<Insights />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  )
}
